import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import { Alert } from "reactstrap";
import Select from "react-select";
import { getcitylist } from "store/participantcity/actions";
import { getdistrictlist } from "store/participantdistrict/actions";
import { getprovincelist } from "store/participantprovince/actions";
import { getdesignationlist } from "store/participantdesignation/actions";
import { getdepartmentlist } from "store/participantdepartment/actions";
import { getcountrylist } from "store/participantcountry/actions";
import { gettypelist } from "store/participanttype/actions";
import { getsectorlist } from "store/participantsector/actions";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Button,
  Input,
} from "reactstrap";
import {
  getApprovedLabs,
  updateMembershipStatus,
  getDeleteParticipant,
} from "store/registration-admin/actions";
import { getParticipantSchemelist } from "store/Payment/actions";
import { getcyclelist } from "store/cycle/actions";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";

// Redux Actions
import {
  getAllLabs,
  updateAllLabs,
  approveUnapproveLab,
} from "store/registration-admin/actions";

import "assets/scss/table.scss";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

class EditParticipantsPage extends Component {
  constructor(props) {
    super(props);

 const participant =
      (this.props.location &&
        this.props.location.state &&
        this.props.location.state.selectedParticipant) ||
      {};    this.state = {
      // Participant data
      id: participant.id || "",
      name: participant.name || "",
      email: participant.email || "",
      address: participant.address || "",
      district: participant.district || "",
      province: participant.province || "",
      city: participant.city || "",
      shipping_address: participant.shipping_address || "",
      billing_address: participant.billing_address || "",
      website: participant.website || "",
      lab_staff_name: participant.lab_staff_name || "",
      lab_staff_designation: participant.lab_staff_designation || "",
      department: participant.department || "",
      country: participant.country || "",
      type: participant.type || "",
      sector: participant.sector || "",
      marketer_name: participant.marketer_name || "",
      email_participant: participant.email_participant || "",
      password_foradmins: participant.password_foradmins || "",
      landline_registered_by: participant.landline_registered_by || "",
      payment_status: participant.payment_status || "",
      payment_settlement: participant.payment_settlement || "",

      // Lists for dropdowns
      ListCity: [],
      ListDistrict: [],
      ListProvince: [],
      ListDesignation: [],
      ListDepartment: [],
      ListCountry: [],
      ListType: [],
      ListSector: [],
      CycleList: [],

      successMessage: "",
      btnText: "Copy",
      organization_name: "",
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
    };

    console.log(
      "Initialized user_id:",
      localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "No authUser found in localStorage"
    );

    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  componentDidMount() {
    const { onGetCityList, onGetDistrictList, onGetProvinceList, onGetdesignationlist, onGetDepartmentList, onGetCountryList, onGettypelist, onGetsectorlist } = this.props;

    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

    if (!user_id) {
      console.error("User ID is missing. Cannot proceed with API calls.");
      return;
    }

    this.setState({ user_id }, () => {
      const { organization_name } = this.props.match.params || {};
      if (organization_name) {
        this.setState({ organization_name }, () => {
          console.log("Organization name set:", this.state.organization_name);
          this.fetchData(user_id);
        });
      } else {
        console.error("Organization name is missing in URL parameters.");
      }
    });

    // Fetch dropdown data
    onGetCityList(user_id);
    onGetDistrictList(user_id);
    onGetProvinceList(user_id);
    onGetdesignationlist(user_id);
    onGetDepartmentList(user_id);
    onGetCountryList(user_id);
    onGettypelist(user_id);
    onGetsectorlist(user_id);
  }

  fetchData(user_id) {
    const { onGetParticipantPayment, ongetApprovedLabs, ongetcyclelist } = this.props;
    onGetParticipantPayment(user_id);
    ongetApprovedLabs(user_id);
    ongetcyclelist(user_id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.participant !== this.props.participant && this.props.participant) {
      const p = this.props.participant;
      this.setState({
        id: p.id || "",
        name: p.name || "",
        email: p.email || "",
        address: p.address || "",
        district: p.district || "",
        province: p.province || "",
        city: p.city || "",
        shipping_address: p.shipping_address || "",
        billing_address: p.billing_address || "",
        website: p.website || "",
        lab_staff_name: p.lab_staff_name || "",
        lab_staff_designation: p.lab_staff_designation || "",
        department: p.department || "",
        country: p.country || "",
        type: p.type || "",
        sector: p.sector || "",
        marketer_name: p.marketer_name || "",
        email_participant: p.email_participant || "",
        password_foradmins: p.password_foradmins || "",
        landline_registered_by: p.landline_registered_by || "",
        payment_status: p.payment_status || "",
        payment_settlement: p.payment_settlement || "",
      });
    }

    // Update dropdown lists if changed
    if (prevProps.ListCity !== this.props.ListCity) {
      this.setState({ ListCity: this.props.ListCity });
    }
    if (prevProps.ListDistrict !== this.props.ListDistrict) {
      this.setState({ ListDistrict: this.props.ListDistrict });
    }
    if (prevProps.ListProvince !== this.props.ListProvince) {
      this.setState({ ListProvince: this.props.ListProvince });
    }
    if (prevProps.ListDesignation !== this.props.ListDesignation) {
      this.setState({ ListDesignation: this.props.ListDesignation });
    }
    if (prevProps.ListDepartment !== this.props.ListDepartment) {
      this.setState({ ListDepartment: this.props.ListDepartment });
    }
    if (prevProps.ListCountry !== this.props.ListCountry) {
      this.setState({ ListCountry: this.props.ListCountry });
    }
    if (prevProps.ListType !== this.props.ListType) {
      this.setState({ ListType: this.props.ListType });
    }
    if (prevProps.ListSector !== this.props.ListSector) {
      this.setState({ ListSector: this.props.ListSector });
    }
  }

  handleEditSubmit(values) {
    console.log("Form values:", values);

    const updatedData = {
      id: this.state.id,
      name: values.name,
      email: values.email,
      province: values.province,
      lab_staff_designation: values.designation,
      password_foradmins: values.password_foradmins,
      department: values.department,
      country: values.country,
      type: values.type,
      sector: values.sector,
      address: values.address,
      shipping_address: values.shipping_address,
      billing_address: values.billing_address,
      website: values.website,
      marketer_name: values.marketer_name,
      city: values.city,
      district: values.district,
      lab_staff_name: values.lab_staff_name,
      email_participant: values.email_participant,
      landline_registered_by: values.landline_registered_by,
      payment_status: values.payment_status,
    };

    this.props.onupdateAllLabs(updatedData);

this.setState({ successMessage: "Participant updated successfully" }, () => {
  window.scrollTo({ top: 0, behavior: 'smooth' }); 
  
});    if (this.props.onSuccess) {
      this.props.onSuccess();
    }

    // Refresh list after 1s
    setTimeout(() => {
      this.props.ongetApprovedLabs(this.state.user_id);
    }, 1000);

    // Redirect back after 2s
    setTimeout(() => {
      this.props.history.push(`/${this.state.organization_name}/participants`);
      this.setState({ successMessage: "" });
    }, 2000);
  }

  handleFileChange(event, setFieldValue) {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  }

  render() {
    const {
      ListCity,
      ListDistrict,
      ListProvince,
      ListDesignation,
      ListDepartment,
      ListCountry,
      ListType,
      ListSector,
    } = this.state;

    const cityOptions = ListCity.map(city => ({ value: city.name, label: city.name }));
    const districtOptions = ListDistrict.map(district => ({ value: district.name, label: district.name }));
    const provinceOptions = ListProvince.map(province => ({ value: province.name, label: province.name }));
    const designationOptions = ListDesignation.map(designation => ({ value: designation.name, label: designation.name }));
    const deptOptions = ListDepartment.map(department => ({ value: department.name, label: department.name }));
    const countryOptions = ListCountry.map(country => ({ value: country.name, label: country.name }));
    const typeOptions = ListType.map(type => ({ value: type.name, label: type.name }));
    const sectorOptions = ListSector.map(sector => ({ value: sector.name, label: sector.name }));

    const customStyles = {
      control: provided => ({
        ...provided,
        minHeight: "38px",
      }),
    };

    return (
      <React.Fragment>
        <div className="page-content" style={{ width: "80%", margin: "100px auto" }}>
          <MetaTags>
            <title>Edit Lab Details | Your App Name</title>
          </MetaTags>
          <Container fluid>
            {/* Breadcrumb */}
            <Breadcrumbs
              title="Participants"
              breadcrumbItem="Edit Lab Details"
            />

            {/* Success Message */}
            {this.state.successMessage && (
              <Row>
                <Col>
                  <Alert color="success" className="text-center">
                    {this.state.successMessage}
                  </Alert>
                </Col>
              </Row>
            )}

            {/* Main Form Card */}
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4">Edit Lab Details</h4>

                    <Formik
                      enableReinitialize
                      initialValues={{
                        id: this.state.id,
                        name: this.state.name,
                        email: this.state.email,
                        password_foradmins: this.state.password_foradmins,
                        address: this.state.address,
                        district: this.state.district,
                        city: this.state.city,
                        province: this.state.province,
                        shipping_address: this.state.shipping_address,
                        billing_address: this.state.billing_address,
                        website: this.state.website,
                        lab_staff_name: this.state.lab_staff_name,
                        email_participant: this.state.email_participant,
                        landline_registered_by: this.state.landline_registered_by,
                        designation: this.state.lab_staff_designation,
                        department: this.state.department,
                        country: this.state.country,
                        type: this.state.type,
                        sector: this.state.sector,
                        payment_status: this.state.payment_status,
                        payment_settlement: this.state.payment_settlement,
                      }}
                      onSubmit={this.handleEditSubmit}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        handleChange,
                        handleSubmit,
                      }) => (
                        <Form onSubmit={handleSubmit}>
                          <Row>
                            <Col className="col-12">
                              <div className="mb-3">
                                <Label className="form-label">Name</Label>
                                <Input
                                  type="text"
                                  name="name"
                                  className="form-control"
                                  placeholder="Enter Name"
                                  value={values.name}
                                  onChange={handleChange}
                                />
                              </div>

                              <Row>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Login Email</Label>
                                    <Input
                                      type="email"
                                      name="email"
                                      className="form-control"
                                      placeholder="Enter Email"
                                      value={values.email}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Password</Label>
                                    <Input
                                      type="text"
                                      name="password_foradmins"
                                      className="form-control"
                                      value={values.password_foradmins}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Website</Label>
                                    <Input
                                      type="text"
                                      name="website"
                                      className="form-control"
                                      value={values.website}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Address</Label>
                                    <Input
                                      type="text"
                                      name="address"
                                      className="form-control"
                                      placeholder="Enter Address"
                                      value={values.address}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Shipping Address</Label>
                                    <Input
                                      type="text"
                                      name="shipping_address"
                                      className="form-control"
                                      placeholder="Enter Shipping Address"
                                      value={values.shipping_address}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Billing Address</Label>
                                    <Input
                                      type="text"
                                      name="billing_address"
                                      className="form-control"
                                      placeholder="Enter Billing Address"
                                      value={values.billing_address}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">District</Label>
                                    <Select
                                      name="district"
                                      options={districtOptions}
                                      styles={customStyles}
                                      className={errors.district && touched.district ? "is-invalid" : ""}
                                      onChange={selectedOption =>
                                        setFieldValue("district", selectedOption ? selectedOption.value : "")
                                      }
                                      value={districtOptions.find(option => option.value === values.district) || null}
                                    />
                                    <ErrorMessage name="district" component="div" className="invalid-feedback" />
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">City</Label>
                                    <Select
                                      name="city"
                                      options={cityOptions}
                                      styles={customStyles}
                                      className={errors.city && touched.city ? "is-invalid" : ""}
                                      onChange={selectedOption =>
                                        setFieldValue("city", selectedOption ? selectedOption.value : "")
                                      }
                                      value={cityOptions.find(option => option.value === values.city) || null}
                                    />
                                    <ErrorMessage name="city" component="div" className="invalid-feedback" />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Province</Label>
                                    <Select
                                      name="province"
                                      options={provinceOptions}
                                      styles={customStyles}
                                      className={errors.province && touched.province ? "is-invalid" : ""}
                                      onChange={selectedOption =>
                                        setFieldValue("province", selectedOption ? selectedOption.value : "")
                                      }
                                      value={
                                        provinceOptions.find(option => option.value === values.province) ||
                                        (values.province ? { value: values.province, label: values.province } : null)
                                      }
                                    />
                                    <ErrorMessage name="province" component="div" className="invalid-feedback" />
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Department</Label>
                                    <Select
                                      name="department"
                                      options={deptOptions}
                                      styles={customStyles}
                                      className={errors.department && touched.department ? "is-invalid" : ""}
                                      onChange={selectedOption =>
                                        setFieldValue("department", selectedOption ? selectedOption.value : "")
                                      }
                                      value={
                                        deptOptions.find(option => option.value === values.department) ||
                                        (values.department ? { value: values.department, label: values.department } : null)
                                      }
                                    />
                                    <ErrorMessage name="department" component="div" className="invalid-feedback" />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Country</Label>
                                    <Select
                                      name="country"
                                      options={countryOptions}
                                      styles={customStyles}
                                      className={errors.country && touched.country ? "is-invalid" : ""}
                                      onChange={selectedOption =>
                                        setFieldValue("country", selectedOption ? selectedOption.value : "")
                                      }
                                      value={
                                        countryOptions.find(option => option.value === values.country) ||
                                        (values.country ? { value: values.country, label: values.country } : null)
                                      }
                                    />
                                    <ErrorMessage name="country" component="div" className="invalid-feedback" />
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Type</Label>
                                    <Select
                                      name="type"
                                      options={typeOptions}
                                      styles={customStyles}
                                      className={errors.type && touched.type ? "is-invalid" : ""}
                                      onChange={selectedOption =>
                                        setFieldValue("type", selectedOption ? selectedOption.value : "")
                                      }
                                      value={
                                        typeOptions.find(option => option.value === values.type) ||
                                        (values.type ? { value: values.type, label: values.type } : null)
                                      }
                                    />
                                    <ErrorMessage name="type" component="div" className="invalid-feedback" />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Sector</Label>
                                    <Select
                                      name="sector"
                                      options={sectorOptions}
                                      styles={customStyles}
                                      className={errors.sector && touched.sector ? "is-invalid" : ""}
                                      onChange={selectedOption =>
                                        setFieldValue("sector", selectedOption ? selectedOption.value : "")
                                      }
                                      value={
                                        sectorOptions.find(option => option.value === values.sector) ||
                                        (values.sector ? { value: values.sector, label: values.sector } : null)
                                      }
                                    />
                                    <ErrorMessage name="sector" component="div" className="invalid-feedback" />
                                  </div>
                                </Col>
                              </Row>

                              <div className="mt-4 mb-3">
                                <h5>Notification Person Details</h5>
                              </div>

                              <Row>
                                <Col md={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Email</Label>
                                    <Input
                                      type="email"
                                      name="email_participant"
                                      className="form-control"
                                      placeholder="Enter Email"
                                      value={values.email_participant}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Name</Label>
                                    <Input
                                      type="text"
                                      name="lab_staff_name"
                                      className="form-control"
                                      placeholder="Enter Name"
                                      value={values.lab_staff_name}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Contact No</Label>
                                    <Input
                                      type="text"
                                      name="landline_registered_by"
                                      className="form-control"
                                      placeholder="Enter Contact No"
                                      value={values.landline_registered_by}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Designation</Label>
                                    <Select
                                      name="designation"
                                      options={designationOptions}
                                      styles={customStyles}
                                      className={errors.designation && touched.designation ? "is-invalid" : ""}
                                      onChange={selectedOption =>
                                        setFieldValue("designation", selectedOption ? selectedOption.value : "")
                                      }
                                      value={
                                        designationOptions.find(option => option.value === values.designation) ||
                                        (values.designation ? { value: values.designation, label: values.designation } : null)
                                      }
                                    />
                                    <ErrorMessage name="designation" component="div" className="invalid-feedback" />
                                  </div>
                                </Col>
                              </Row>

                              <div className="mt-4 text-end">
                                <Button type="submit" color="primary" className="me-2">
                                  Save Changes
                                </Button>
                                <Button
                                  type="button"
                                  color="secondary"
                                  onClick={() => this.props.history.goBack()}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

EditParticipantsPage.propTypes = {
  match: PropTypes.object,
  history: PropTypes.any,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  participant: PropTypes.any,
  onSuccess: PropTypes.func,

  // Redux Props
  ListCity: PropTypes.array,
  ListDistrict: PropTypes.array,
  ListProvince: PropTypes.array,
  ListDesignation: PropTypes.array,
  ListDepartment: PropTypes.array,
  ListCountry: PropTypes.array,
  ListType: PropTypes.array,
  ListSector: PropTypes.array,
  CycleList: PropTypes.array,

  // Redux Dispatchers
  onGetCityList: PropTypes.func,
  onGetDistrictList: PropTypes.func,
  onGetProvinceList: PropTypes.func,
  onGetdesignationlist: PropTypes.func,
  onGetDepartmentList: PropTypes.func,
  onGetCountryList: PropTypes.func,
  onGettypelist: PropTypes.func,
  onGetsectorlist: PropTypes.func,
  onupdateAllLabs: PropTypes.func,
  ongetApprovedLabs: PropTypes.func,
  ongetcyclelist: PropTypes.func,
  onGetParticipantPayment: PropTypes.func,
  location: PropTypes.shape({
      state: PropTypes.shape({
        selectedParticipant: PropTypes.object,
      }),
      search: PropTypes.string,
    }),
};

const mapStateToProps = ({
  Account,
  registrationAdmin,
  ListCity,
  ListDistrict,
  ListProvince,
  ListDesignation,
  ListDepartment,
  ListCountry,
  ListType,
  ListSector,
}) => ({
  userID: Account.userID,
  AllLabs: registrationAdmin.AllLabs,
  approvedLabs: registrationAdmin.approvedLabs || [],
  CycleList: registrationAdmin.CycleList || [],
  ListCity: ListCity?.ListCity || [],
  ListDistrict: ListDistrict?.ListDistrict || [],
  ListProvince: ListProvince?.ListProvince || [],
  ListDesignation: ListDesignation?.ListDesignation || [],
  ListDepartment: ListDepartment?.ListDepartment || [],
  ListCountry: ListCountry?.ListCountry || [],
  ListType: ListType?.ListType || [],
  ListSector: ListSector?.ListSector || [],
});

const mapDispatchToProps = dispatch => ({
  onGetCityList: id => dispatch(getcitylist(id)),
  onGetDistrictList: id => dispatch(getdistrictlist(id)),
  onGetProvinceList: id => dispatch(getprovincelist(id)),
  onGetdesignationlist: id => dispatch(getdesignationlist(id)),
  onGetDepartmentList: id => dispatch(getdepartmentlist(id)),
  onGetCountryList: id => dispatch(getcountrylist(id)),
  onGettypelist: id => dispatch(gettypelist(id)),
  onGetsectorlist: id => dispatch(getsectorlist(id)),

  onupdateAllLabs: data => dispatch(updateAllLabs(data)),
  ongetApprovedLabs: id => dispatch(getApprovedLabs(id)),
  ongetcyclelist: id => dispatch(getcyclelist(id)),
  onGetParticipantPayment: id => dispatch(getParticipantSchemelist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EditParticipantsPage));